define([
    "./monitorableMapViewModule",
    "angular",
    "text!./monitorableMapView.html",
    "text!../occurrences/OccurrencePopupTemplate.html",
    "text!../occurrences/OccurrenceListPopupTemplate.html",
    "lodash"
], function (module, angular, template, occurrencePopupTemplate, occurrenceListPopupTemplate, _) {
    "use strict";

    return module.directive("monitorableMapView", [function () {
        return {
            restrict: "E",
            scope: {
                tracking: "=",
                monitorable: "=",
                configurations: "<?",
                hereMapApi: "=?",
            },
            template: template,
            controller: ["$scope",
                "$q",
                "monitoringService",
                "markerImage",
                "markerService",
                "DataFetcherType",
                "mbrService",
                "remoteExceptionHandler",
                "nlgTagInputIconMapMonitoring",
                ($scope, $q, monitoringService, markerImage, markerService, DataFetcherType, mbrService, remoteExceptionHandler, nlgTagInputIconMapMonitoring) => {

                    $scope.here = {
                        routes: [],
                        markersPoints: [],
                        staticRoutes: [],
                        stopsIcons: new Set(),
                        refresh: reloadEntity
                    }

                    let routesHereApi = null
                    $scope.onRegisterHereApi = (api) => {
                        routesHereApi = api
                        if ($scope.hereMapApi) {
                            $scope.hereMapApi(routesHereApi)
                        }
                    }

                    init();

                    $scope.isTrackingMonitorableInExecution = function (trackingMonitorable) {
                        return !trackingMonitorable.finished;
                    }

                    $scope.isSomeTrackingMonitorableLoadingInAllTrackingMonitorables = function () {
                        let tracking = $scope.tracking;
                        let trackingMonitorablesByClassification = tracking.trackingMonitorablesByClassification;
                        let primaryLoading = getIsSomeTrackingMonitorableLoading(trackingMonitorablesByClassification.primary.trackingMonitorables);
                        let secondaryLoading = getIsSomeTrackingMonitorableLoading(trackingMonitorablesByClassification.secondary.trackingMonitorables);
                        return primaryLoading || secondaryLoading;
                    }

                    $scope.isSomeSecondaryTrackingMonitorableLoading = function () {
                        let tracking = $scope.tracking;
                        let trackingMonitorablesByClassification = tracking.trackingMonitorablesByClassification;
                        return getIsSomeTrackingMonitorableLoading(trackingMonitorablesByClassification.secondary.trackingMonitorables);
                    }

                    $scope.isTrackingMonitorableLoading = function (trackingMonitorable) {
                        if (trackingMonitorable.isLoading.length === 0) {
                            return false;
                        }
                        return trackingMonitorable.trackingMonitorableIds.length === trackingMonitorable.isLoading.length
                    }

                    $scope.getTripRouteByAllPrimaryTrackingMonitorables = function (isAllSelected) {
                        let trackingMonitorablesByClassification = $scope.tracking.trackingMonitorablesByClassification;
                        let primary = trackingMonitorablesByClassification.primary;
                        let secondary = trackingMonitorablesByClassification.secondary;

                        setIsPrimaryView(true);
                        setAllTrackingMonitorablesByClassification(primary.trackingMonitorables, isAllSelected);
                        setAllTrackingMonitorablesByClassification(secondary.trackingMonitorables, false);
                        loadRealizedRoute(0, 150);
                    };

                    $scope.getTripRouteByPrimaryTrackingMonitorable = function () {
                        let trackingMonitorablesByClassification = $scope.tracking.trackingMonitorablesByClassification;
                        let primary = trackingMonitorablesByClassification.primary;
                        let secondary = trackingMonitorablesByClassification.secondary;

                        let isAllPrimaryTrackingMonitorableIsSelected = verifyAllPrimaryTrackingMonitorablesIsSelected(primary);

                        setIsPrimaryView(true);
                        setAllSelectedPrimary(isAllPrimaryTrackingMonitorableIsSelected);
                        setAllTrackingMonitorablesByClassification(secondary.trackingMonitorables, false);
                        loadRealizedRoute(0, 150);
                    };

                    $scope.getTripRouteBySecondaryTrackingMonitorable = function (currentTrackingMonitorableSecondary) {
                        let trackingMonitorablesByClassification = $scope.tracking.trackingMonitorablesByClassification;
                        let primary = trackingMonitorablesByClassification.primary;
                        let secondary = trackingMonitorablesByClassification.secondary;

                        setIsPrimaryView(false);
                        setAllSelectedPrimary(false);
                        setAllTrackingMonitorablesByClassification(primary.trackingMonitorables, false);

                        secondary.trackingMonitorables.forEach(trackingMonitorable => {
                            if (currentTrackingMonitorableSecondary.deviceId !== trackingMonitorable.deviceId) {
                                trackingMonitorable.isSelected = false;
                            }
                        })
                        loadRealizedRoute(0, 150);
                    };

                    function getIsSomeTrackingMonitorableLoading(trackingMonitorables) {
                        if (!trackingMonitorables) {
                            return true;
                        }
                        return trackingMonitorables.some(trackingMonitorable => {
                            return $scope.isTrackingMonitorableLoading(trackingMonitorable) === false;
                        });
                    }

                    function setAllTrackingMonitorablesByClassification(trackingMonitorables, isAllSelected) {
                        trackingMonitorables.forEach(trackingMonitorable => {
                            trackingMonitorable.isSelected = isAllSelected;
                        })
                    }

                    function setIsPrimaryView(isPrimaryView) {
                        $scope.tracking.trackingMonitorablesByClassification.isPrimaryView = isPrimaryView;
                    }

                    function verifyAllPrimaryTrackingMonitorablesIsSelected(primary) {
                        let trackingMonitorables = primary.trackingMonitorables;
                        return trackingMonitorables.every(trackingMonitorable => {
                            return trackingMonitorable.isSelected === true;
                        });
                    }

                    function setAllSelectedPrimary(isAllSelected) {
                        let primary = $scope.tracking.trackingMonitorablesByClassification.primary;
                        if (isAllSelected) {
                            return primary.isAllSelected = true;
                        }
                        return primary.isAllSelected = false;
                    }

                    function init() {
                        return $q.all([
                            loadRoute(),
                            loadEntityStatus()
                        ]);
                    }

                    function reloadEntity() {
                        return monitoringService.findMonitorableAssociatedTransitionGroupWithSameLocality($scope.monitorable.id)
                            .catch(remoteExceptionHandler())
                            .then(function (monitorable) {
                                $scope.monitorable = monitorable;
                            })
                            .then(loadEntityStatus)
                    }

                    function loadEntityStatus() {
                        return $q.all([
                            loadTrackingDetails(),
                            loadOccurrenceMarkers(),
                            loadTrackingMonitorable(),
                        ]);
                    }

                    function loadTrackingDetails() {
                        if (!!$scope.monitorable.trackingDetails) {
                            let lastPosition = $scope.monitorable.trackingDetails.lastPosition;
                            if (lastPosition.latitude !== 0.0 && lastPosition.longitude !== 0.0) {
                                $scope.tracking.lastSignal = $scope.monitorable.trackingDetails.lastPosition;
                            }
                        }
                        drawTruckMarker()
                    }

                    function drawTruckMarker() {
                        if (!$scope.tracking.lastSignal) {
                            return;
                        }
                        let iconUrl = markerImage.getIcon();

                        var geographicInfo = {
                            latitude: $scope.tracking.lastSignal.latitude,
                            longitude: $scope.tracking.lastSignal.longitude
                        }
                        $scope.here.markersPoints = [{
                            geographicInfo: geographicInfo,
                            data: {
                                id: $scope.monitorable.id,
                                montirableSourceId: $scope.monitorable.sourceId,
                                icon: iconUrl,
                                geographicInfo: geographicInfo
                            }
                        }]
                    }

                    function loadOccurrenceMarkers() {
                        $scope.here.clusterMarkersPoints = []
                        var ocurrences = [];
                        monitoringService.findMonitorableById($scope.monitorable.id, [DataFetcherType.CHILDREN, DataFetcherType.OCCURRENCE])
                            .then(function (monitorableWithChildren) {
                                return _.flattenDeep(_.map([monitorableWithChildren], allOccurrences))
                                    .filter(function (occurrence) {
                                        return !!occurrence.where;
                                    })
                                    .map(function (occurrence) {
                                        ocurrences.push(occurrence)
                                        return markerService.createMarker(
                                            $scope.monitorable.sourceId,
                                            occurrence.id,
                                            occurrence.where,
                                            occurrence.status.presentationInfo ? occurrence.status.presentationInfo.mapIconUrl : "images/warning.png",
                                            {
                                                template: occurrencePopupTemplate,
                                                templateParameter: {
                                                    currentDriver: $scope.monitorable.currentDriver,
                                                    monitorableCode: $scope.monitorable.sourceId,
                                                    occurrence: occurrence
                                                }
                                            });
                                    });
                            }).then(function (markers) {
                            $scope.here.clusterMarkersPoints = ocurrences.map(function (occurrence) {
                                var geographicInfo = {
                                    latitude: occurrence.where.latitude,
                                    longitude: occurrence.where.longitude,
                                }
                                return {
                                    geographicInfo: geographicInfo,
                                    data: {
                                        id: occurrence.id,
                                        monitorableSourceId: $scope.monitorable.sourceId,
                                        icon: occurrence.status.presentationInfo ? occurrence.status.presentationInfo.mapIconUrl : "images/warning.png",
                                        geographicInfo: geographicInfo,
                                        popUp: {
                                            template: occurrenceListPopupTemplate,
                                            templateParameter: {
                                                currentDriver: $scope.monitorable.currentDriver,
                                                monitorableCode: $scope.monitorable.sourceId,
                                                occurrence: occurrence
                                            }
                                        }
                                    }
                                }
                            })
                        });
                    }

                    function allOccurrences(node) {
                        if (node.children && node.children.length > 0) {
                            return node.occurrences.concat(_.flattenDeep(_.map(node.children, allOccurrences)))
                        } else {
                            return node.occurrences
                        }
                    }

                    function loadTrackingMonitorable() {
                        setDefaultTrackingMonitorablesByClassification()
                        setDefaultTruckDevice()
                        mbrService.getUniqueTrackingMonitorable($scope.monitorable.id).then(function (trackingMonitorables) {
                            $scope.tracking.trackingMonitorables = trackingMonitorables;
                            $scope.trackingMonitorablePromiseResolved = true;
                            trackingMonitorablesByClassificationServiceBuild($scope.tracking.trackingMonitorables);
                            loadRealizedRoute(0, 150);
                        });
                    }

                    function loadRealizedRoute(page, size) {
                        let selectedTrackingMonitorableIds = getSelectedTrackingMonitorableIds();
                        getLoadRealizedRoute(selectedTrackingMonitorableIds, page, size)
                    }

                    function loadRoute() {
                        return monitoringService.getPlannedRoutePathOfTrip($scope.monitorable.id)
                            .then(function (routes) {
                                $scope.here.routes = routes;
                                $scope.here.routes.forEach(function (route) {
                                    route.stopMarkers = route.stops.map(function (stop) {
                                        var iconMapElement = nlgTagInputIconMapMonitoring.iconMap()[stop.stopIcon];
                                        $scope.here.stopsIcons.add(iconMapElement)
                                        return {
                                            geographicInfo: stop.address.geographicInfo,
                                            data: {
                                                id: stop.localityId,
                                                routeId: route.tripCode,
                                                geographicInfo: stop.address.geographicInfo,
                                                icon: iconMapElement,
                                                stop: stop,
                                                stopInfo: {
                                                    tripCode: route.tripCode,
                                                    stopNumber: stop.stopIconText,
                                                    stopName: stop.stopName,
                                                    stopAddress: stop.address,
                                                    eta: stop.arrivalTime,
                                                    plate: route.truckPlate || "N/A"
                                                }
                                            }
                                        };
                                    });
                                });
                            })
                    }

                    function setDefaultTrackingMonitorablesByClassification() {
                        $scope.tracking.trackingMonitorablesByClassification = {
                            primary: {
                                trackingMonitorables: [],
                                isAllSelected: false,
                            },
                            secondary: {
                                trackingMonitorables: [],
                            },
                            isPrimaryView: true,
                        }
                    }

                    function setDefaultTruckDevice() {
                        $scope.tracking.truckDevice = {};
                    }

                    function trackingMonitorablesByClassificationServiceBuild(trackingMonitorables) {
                        if (!trackingMonitorables) {
                            return;
                        }
                        let tracking = $scope.tracking;
                        let trackingMonitorablesByClassification = tracking.trackingMonitorablesByClassification;
                        trackingMonitorables.forEach(function (trackingMonitorable) {
                            let isPrimary = trackingMonitorable.primary;
                            setIsLoading(trackingMonitorable, false);
                            if (isPrimary) {
                                trackingMonitorablesByClassification.primary.trackingMonitorables.push(trackingMonitorable);
                                return;
                            }
                            trackingMonitorablesByClassification.secondary.trackingMonitorables.push(trackingMonitorable);
                        })
                        setSelectedFirstTrackingMonitorable(trackingMonitorablesByClassification.primary.trackingMonitorables)
                        if (hasOnlyOnePrimaryTrackingMonitorable(trackingMonitorablesByClassification)) {
                            setAllSelectedPrimary(true);
                        }
                        setTruckDevice(trackingMonitorablesByClassification.primary.trackingMonitorables)
                    }

                    function setSelectedFirstTrackingMonitorable(trackingMonitorables) {
                        if (trackingMonitorables.length === 0) {
                            return
                        }
                        let trackingMonitorable = getFirstTrackingMonitorable(trackingMonitorables);
                        trackingMonitorable.isSelected = true;
                    }

                    function setIsLoading(trackingMonitorable, boolean) {
                        trackingMonitorable.isLoading = []
                        trackingMonitorable.trackingMonitorableIds.forEach(function () {
                            trackingMonitorable.isLoading.push(boolean)
                        })
                    }

                    function hasOnlyOnePrimaryTrackingMonitorable(trackingMonitorablesByClassification) {
                        let hasOnlyOneRecord = 1;
                        let primaryTrackingMonitorables = trackingMonitorablesByClassification.primary.trackingMonitorables;
                        return primaryTrackingMonitorables.length === hasOnlyOneRecord;
                    }

                    function setTruckDevice(trackingMonitorables) {
                        if (trackingMonitorables.length === 0) {
                            return;
                        }
                        let trackingMonitorable = getFirstTrackingMonitorable(trackingMonitorables);
                        $scope.tracking.truckDevice = {
                            providerId: trackingMonitorable.providerId,
                            deviceId: trackingMonitorable.deviceId,
                            status: trackingMonitorable.status
                        };
                    }

                    function getFirstTrackingMonitorable(trackingMonitorables) {
                        return trackingMonitorables[0];
                    }

                    function getSelectedTrackingMonitorableIds() {
                        let trackingMonitorablesByClassification = $scope.tracking.trackingMonitorablesByClassification;
                        if (trackingMonitorablesByClassification.isPrimaryView) {
                            return getSelectedTrackingMonitorableIdsByClassification(trackingMonitorablesByClassification.primary.trackingMonitorables);
                        }
                        return getSelectedTrackingMonitorableIdsByClassification(trackingMonitorablesByClassification.secondary.trackingMonitorables);
                    }

                    function getSelectedTrackingMonitorableIdsByClassification(trackingMonitorables) {
                        let selectedTrackingDeviceIds = []
                        if (!trackingMonitorables) {
                            return selectedTrackingDeviceIds;
                        }
                        trackingMonitorables.forEach(function (trackingMonitorable) {
                            if (trackingMonitorable.isSelected && isAlreadyTrackingMonitorableLoading(trackingMonitorable)) {
                                trackingMonitorable.isLoading = []
                                trackingMonitorable.trackingMonitorableIds.forEach(trackingMonitorableId => {
                                    selectedTrackingDeviceIds.push(trackingMonitorableId);
                                })
                            }
                        })
                        return selectedTrackingDeviceIds;
                    }

                    function isAlreadyTrackingMonitorableLoading(trackingMonitorable) {
                        return trackingMonitorable.isLoading.length > 0;
                    }

                    function getLoadRealizedRoute(selectedTrackingMonitorableIds, page, size) {
                        $scope.here.staticRoutes = []
                        selectedTrackingMonitorableIds.forEach(function (selectedTrackingMonitorableId) {
                            let currentRealizedRoute = [];
                            recursivelyLoadRealizedRoute(currentRealizedRoute, selectedTrackingMonitorableId, page, size).then(
                                function (realizedRoute) {
                                    $scope.here.staticRoutes.push(realizedRoute);
                                    setCompleteLoadingSelectedTrackingMonitorable(selectedTrackingMonitorableId)
                                }
                            )
                        })
                    }

                    function setCompleteLoadingSelectedTrackingMonitorable(selectedTrackingMonitorableId) {
                        let trackingMonitorablesByClassification = $scope.tracking.trackingMonitorablesByClassification;
                        if (trackingMonitorablesByClassification.isPrimaryView) {
                            return setLoadingTrackingMonitorableIdsByClassification(trackingMonitorablesByClassification.primary.trackingMonitorables, selectedTrackingMonitorableId);
                        }
                        return setLoadingTrackingMonitorableIdsByClassification(trackingMonitorablesByClassification.secondary.trackingMonitorables, selectedTrackingMonitorableId);
                    }

                    function setLoadingTrackingMonitorableIdsByClassification(trackingMonitorables, selectedTrackingMonitorableId) {
                        let selectTrackingMonitorable = trackingMonitorables.filter(function (trackingMonitorable) {
                            return trackingMonitorable.trackingMonitorableIds.includes(selectedTrackingMonitorableId)
                        });
                        if (!selectTrackingMonitorable) {
                            return;
                        }
                        selectTrackingMonitorable[0].isLoading.push(true)
                    }

                    function recursivelyLoadRealizedRoute(currentRealizedRoute, selectedTrackingMonitorableId, page, size) {
                        return monitoringService.getRoutePathOfTripBySelectedTrackingMonitorableIds($scope.monitorable.id, selectedTrackingMonitorableId, page, size)
                            .then(function (realizedRoute) {
                                if (realizedRoute.length === 0) {
                                    return currentRealizedRoute;
                                }
                                if (currentRealizedRoute.length === 0) {
                                    currentRealizedRoute = realizedRoute;
                                } else {
                                    currentRealizedRoute = [{
                                        color: currentRealizedRoute[0].color,
                                        path: currentRealizedRoute[0].path.concat(realizedRoute[0].path)
                                    }]
                                }
                                page += 1;
                                return recursivelyLoadRealizedRoute(currentRealizedRoute, selectedTrackingMonitorableId, page, size)
                            });
                    }

                }]
        };
    }]);
});